import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import H2 from "ReusableComponents/Text/H2";
import { SIZES } from "theme";

const AboutUsInfo = ({ info, small }) => {
  return (
    <Box
      textAlign="center"
      display="flex"
      flexDirection="column"
      padding={small ? "40px 20px" : "0 80px"}
      marginTop={small ? 0 : "80px"}
    >
      <H2
        textColor="white"
        fontWeight="bold"
        fontSize={small ? SIZES.twentyFour : "40px"}
        margin={small ? 0 : "40px 0"}
      >
        {info?.attributes?.title}
      </H2>
      <Box margin="24px auto" w={small ? "100%" : "1060px"}>
        <Text
          textColor="#B8B8B8"
          fontSize={small ? SIZES.fourteen : "20px"}
          lineHeight="1.5"
          margin="0"
        >
          {info?.attributes?.description}
        </Text>
        <Text
          textColor="#B8B8B8"
          fontSize={small ? SIZES.fourteen : "20px"}
          margin="20px 0"
          lineHeight="2"
        >
          {info?.attributes?.description2}
        </Text>
      </Box>
    </Box>
  );
};

export default AboutUsInfo;
